"use strict";

var find = require("./find.js");

var isMatch = require("./isMatch.js");

var curry = require("./curry.js");

module.exports = curry(function findWhere(w, iter) {
  return find(isMatch(w), iter);
});